import {
    IconButton, Label, Stack, Text, TextField
} from "@fluentui/react";
import { RootState } from "app/store";
import { textProp } from "global/Application";
import * as FAM from "model/FlexibleAttributeModel";
import React from "react";
import { connect, ConnectedProps } from "react-redux";
import EntityLink from "./EntityLink";


interface IProps extends TComponentConnectedProps {
    label?: string;
    onLookup?: () => void;
    defaultValue?: string;
    value?: string;
    disabled?: boolean;
    // if they can manually type in lookup
    freeForm?: boolean;
    valueEntityReference?: FAM.IEntityReferenceValue;
    fieldValueOnChange?: (event: any, value: FAM.IEntityReferenceValue | null) => void;
    required?: boolean;
    onDelete?: () => void;
    placeHolder?: string;
    description?: string;
}

const LookupControlBase: React.FC<IProps> = (props) => {

    // 1) Serialization layer would not care about this
    const onLookup = () => {
        if (props.disabled)
            return;

        // custom lookup?
        if (props.onLookup) {
            props.onLookup();
        }
    }

    const onDelete = () => {
        if (props.disabled)
            return;

        // custom lookup?
        if (props.onDelete) {
            props.onDelete();
        }
    }

    if (props.disabled)
        if (props.valueEntityReference)
            return <div style={textProp.root.style}>
                <Label styles={textProp.label}>{props.label}</Label>
                <EntityLink styles={textProp.textStyles} entity={props.valueEntityReference!} />
            </div>;
        else
            return <div style={textProp.root.style}>
                <Label styles={textProp.label}>{props.label}</Label>
                <Text styles={textProp.textStyles}>{props.value ?? props.defaultValue ?? '---'}</Text>
            </div>;

    return <TextField
        required={props.required}
        label={props.label}
        defaultValue={props.value
            ? undefined
            : (props.defaultValue ?? "...")
        }
        placeholder={props.placeHolder}
        value={props.value}
        styles={{ field: { cursor: 'pointer' }, suffix: { backgroundColor: 'transparent' } }}
        onClick={onLookup}
        onKeyDown={(event) => {
            if (event.key === "Enter")
                onLookup();
        }}
        readOnly={!props.freeForm}
        disabled={props.disabled}
        description={props.description}
        onRenderInput={props.valueEntityReference
            ? (defaultProps, defaultRender) => {
                return <div style={{ width: '100%', paddingTop: '6px', paddingLeft: '7px' }} onClick={onLookup}>
                    <EntityLink entity={props.valueEntityReference!} disabled={props.disabled} />
                </div>;
            }
            : undefined
        }
        onRenderSuffix={(scopeProps, defaultRender) => {
            if (props?.disabled)
                return defaultRender?.(scopeProps) ?? <></>;

            return (
                <Stack horizontal>
                    {props.onDelete &&
                        <IconButton
                            iconProps={{ iconName: 'Clear', styles: { root: { fontSize: 'x-small', padding: '5px' } } }}
                            styles={{ root: { height: '100%' } }}
                            onClick={onDelete}
                        />
                    }
                    {props.onLookup &&
                        <IconButton
                            iconProps={{ iconName: 'Search', styles: { root: { fontSize: 'small', padding: '5px' } } }}
                            styles={{ root: { height: '100%' } }}
                            onClick={onLookup}
                        />
                    }
                </Stack>
            );
        }}
        onChange={() => {

        }}
    />
}


function mapStateToProps(state: RootState) { return { state } }
const connector = connect(mapStateToProps);
type TComponentConnectedProps = ConnectedProps<typeof connector>;
export default connector(LookupControlBase)
